import { render } from "./SalesOrder_View.vue?vue&type=template&id=c0b92d4a"
import script from "./SalesOrder_View.vue?vue&type=script&lang=js"
export * from "./SalesOrder_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__